import React, { useEffect, useState } from "react";

//styles
import "./styles.scss";

//router
import { NavLink, useLocation, useNavigate } from "react-router-dom";

//assets
import assets from "../../../Assets/index";
import logo from "../../../Assets/Svg/Auth/Logo.svg";
import LogoutIcon from "../../../Assets/Svg/Auth/Logout.svg";

//custom components
import LogoutModal from "Components/LogoutModal";

// Redux
import { useDispatch } from "react-redux";
import { logoutRequest } from "../../../Redux/Slices/authSlice";

const Sidebar = ({ open, onToggle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch(); // Initialize Redux dispatch

  // Your dynamic navLink state
  const [navLink] = useState([
    {
      to: "/",
      label: "Dashboard",
      Icon: assets.Icons.dashboardIcon,
      ActiveIcon: assets.Icons.activeDashboardIcon,
      id: "1",
      value: "Dashboard",
    },
    {
      to: "/request",
      label: "Request",
      Icon: assets.Icons.requestIconNew,
      ActiveIcon: assets.Icons.requestIconNew,
      id: "2",
      value: "Request Management",
    },
    {
      to: "/chooseKg",
      label: "Choose KG",
      Icon: assets.Icons.requestIcon,
      ActiveIcon: assets.Icons.activeRequestIcon,
      id: "2",
      value: "Choose KG Management",
    },
     {
      to: "/mining",
      label: " KG Mining ",
      Icon: assets.Icons.requestIcon,
      ActiveIcon: assets.Icons.activeRequestIcon,
      id: "10",
      value: "Mining Management",
    },
    {
      to: "/companyManagement",
      label: "Company Management",
      Icon: assets.Icons.companyManagementIcon,
      ActiveIcon: assets.Icons.activeCompanyManagementIcon,
      id: "3",
      value: "Company Management",
    },
    {
      to: "/userManagement",
      label: "User Management",
      Icon: assets.Icons.usersManagementIcon,
      ActiveIcon: assets.Icons.activeUserManagementIcon,
      id: "4",
      value: "User Management",
    },
    {
      to: "/contentManagement",
      label: "Content Management",
      Icon: assets.Icons.contentManagementIcon,
      ActiveIcon: assets.Icons.activeContentManagementIcon,
      id: "5",
      value: "Content Management",
    },
    {
      to: "/staffManagement",
      label: "Staff Management",
      Icon: assets.Icons.staffManagementIcon,
      ActiveIcon: assets.Icons.activeStaffManagementIcon,
      id: "6",
      value: "Staff Management",
    },
    {
      to: "/contact-management",
      label: "Contact Enquiries",
      Icon: assets.Icons.contactEnquiriesIcon,
      ActiveIcon: assets.Icons.contactEnquiriesIcon,
      id: "9",
      value: "Contact Management",
    },
    {
      to: "/productCatalog",
      label: "Product Catalog",
      Icon: assets.Icons.contentManagementIcon,
      ActiveIcon: assets.Icons.activeContentManagementIcon,
      id: "7",
      value: "Product Catalog",
    },
    {
      to: "/settings",
      label: "Settings",
      Icon: assets.Icons.settingsIcon,
      ActiveIcon: assets.Icons.activeSettingsIcon,
      id: "8",
      value: "Settings",
    },
  ]);

  const [mainLinks, setMainLinks] = useState([]);

  // Handle logout functionality
  const handleLogout = () => {
    dispatch(
      logoutRequest({
        callBack: logoutRequestCB,
      })
    );
  };

  const logoutRequestCB = () => {
    setIsModalOpen(false);
    navigate("/login");
    localStorage?.setItem("isLoggedIn", null);
    localStorage?.setItem("userDetails", null);
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage?.getItem("userDetails"));

    if (userDetails?.access_details?.length > 0) {
      const updatedA = navLink.filter((item) =>
        userDetails?.access_details.includes(item.value) ||
        (item.value === "Mining Management" && (userDetails?.access_details.includes("KG Mining") || userDetails?.access_details.includes("Mining Management"))) ||
        (item.value === "Choose KG Management" && (userDetails?.access_details.includes("Choose KG") || userDetails?.access_details.includes("Choose KG Management"))) ||
        (item.value === "Contact Management" && (userDetails?.access_details.includes("Contact Enquiries") || userDetails?.access_details.includes("Contact Management")))
      );
      updatedA.push({
        to: "/settings",
        label: "Settings",
        Icon: assets.Icons.settingsIcon,
        ActiveIcon: assets.Icons.activeSettingsIcon,
        id: "8",
        value: "Settings",
      });

      setMainLinks(updatedA);
    } else {
      let navLinks = [...navLink];
      setMainLinks([...navLinks]);
    }
  }, [navLink]);

  const location = useLocation();

  return (
    <div className="sideBarContainer">
      <img className="kgLogo" src={logo} alt="kgLogo" />
      <hr />
      <div className="pages">
        {/* Dynamically render links from navLink */}
        {mainLinks.map((link) => (
          <div key={link.id} className="page">
            <NavLink
              key={link.id}
              to={link.to}
              style={{ textDecoration: "none" }}
              className={({ isActive }) =>
                isActive ? "active-pageNav" : "pageNav"
              }
              isActive={(match, location) => {
                // Exact match for the Dashboard route "/"
                if (link.to === "/") {
                  return location.pathname === "/";
                }
                // For other routes, check if the pathname starts with the link's route
                return location.pathname.startsWith(link.to);
              }}
            >
              <img
                src={
                  (link.to === "/" && location.pathname === "/") ||
                  (link.to !== "/" && location.pathname.startsWith(link.to))
                    ? link.ActiveIcon
                    : link.Icon
                }
                alt={link.label}
              />
              {link.label}
            </NavLink>
          </div>
        ))}
        <div className="page">
          <NavLink
            style={{ textDecoration: "none" }}
            className="logoutNav"
            onClick={() => setIsModalOpen(true)}
          >
            <img src={LogoutIcon} alt="logout" />
            Logout
          </NavLink>
        </div>
        {isModalOpen && (
          <LogoutModal
            onCancel={() => setIsModalOpen(false)}
            onLogout={handleLogout}
          />
        )}
      </div>
    </div>
  );
};

export default Sidebar;
